import axios from "axios";
import { API_BASE_URL, API_BASE_URL1, API_BASE_URL3 } from "../Services/baseApiUrl";
import axiosInstance from "../../Hooks/axoisInstance";

const getToken = () => {
    return localStorage.getItem("token");
}

export const getAllTransferStationMaster = async () => {
    try {
        const response = await axiosInstance.get(API_BASE_URL1 + `MasterDetails/GetAllTransferstation`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            },
        );
        const data = response.data;
        if (Array.isArray(data)) return data;
        if (Array.isArray(data?.data)) return data.data;
        if (Array.isArray(data?.result)) return data.result;
        return [];

    } catch (error) {
        throw error
    }
}

export const getTransferStationsByType = async (transferStationType) => {
    try {
        const response = await axiosInstance.get(
            API_BASE_URL3 +
                `MasterDetails/GetAllTransferstations?transferStationType=${transferStationType}`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getTransferStationTypes = async () => {
    try {
        const response = await axiosInstance.get(
            API_BASE_URL1 + `TransferStation/GetTransferStationTypes`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const createTransferStationMaster = async (transferStationData) => {
    try {
        const response = await axiosInstance.post(API_BASE_URL1 + `TransferStation/AddNewTransferStation`, transferStationData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${getToken()}`
                },

            });
        console.log("response", response);

        return response;
    } catch (error) {
        throw error

    }
};

export const updateTransferStationMaster = async (id, requestData) => {
    try {
        const response = await axiosInstance.put(API_BASE_URL1 + `TransferStation/UpdateTransferStation`, requestData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${getToken()}`
                },

            });

        return response;
    } catch (error) {
        throw error

    }
};

export const getTransferStationById = async (id) => {
    try {
        const response = await axiosInstance.get(API_BASE_URL1 + `transfer_station/getById/${id}`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                },

            });
        // console.log(response, 'response')
        return response;
    } catch (error) {
        throw error

    }
};

export const getAllTransferStationInchargeMaster = async () => {
    try {
        const response = await axiosInstance.get(API_BASE_URL1 + `TransferStation/GetAllTransferStationIncharges`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            },
        );
        return response.data;

    } catch (error) {
        throw error
    }
}

export const createTransferStationInchargeMaster = async (transferStationData) => {
    try {
        const response = await axiosInstance.post(API_BASE_URL1 + `TransferStation/AddNewTransferStationIncharges`, transferStationData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${getToken()}`
                },

            });
        console.log("response", response);

        return response;
    } catch (error) {
        throw error

    }
};

export const updateTransferStationInchargeMaster = async (id, requestData) => {
    try {
        const response = await axiosInstance.put(API_BASE_URL1 + `TransferStation/UpdateTransferStationIncharge`, requestData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${getToken()}`
                },

            });

        return response;
    } catch (error) {
        throw error

    }
};

export const GetAllAssociatedTransferStations = async () => {
    try {
        const response = await axiosInstance.get(API_BASE_URL1 + `TransferStation/GetAllTransferStations`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            },
        );
        return response.data;

    } catch (error) {
        throw error
    }
}
